import { render, staticRenderFns } from "./pdButton.vue?vue&type=template&id=04282969"
import script from "./pdButton.vue?vue&type=script&lang=js"
export * from "./pdButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports